<script lang="ts" setup>
  import useMarkdown from '~/composables/Markdown/Markdown'
  import {
    ContentBlockInfoBoxData,
    ContentBlockTypeId,
  } from '~/model/ContentBlockData/ContentBlockData'
  import { UseBemProps } from '~/composables/Bem/BemFacetOptions'
  import useBem from '~/composables/Bem/Bem'
  import useContentBlockAlign from '~/composables/ContentBlockAlign/ContentBlockAlign'

  interface Props extends UseBemProps, ContentBlockInfoBoxData {
    type: ContentBlockTypeId
    facets?: Array<string>
    richText: string
  }

  const props = defineProps<Props>()
  const { parseMarkdown } = useMarkdown()
  const { bemFacets } = useBem('c-content-block-info-box', props, {})
  const { contentBlockAlignFacets } = useContentBlockAlign(props)

  const rootClasses = computed<Array<string>>(() => {
    return [...bemFacets.value, ...contentBlockAlignFacets.value]
  })
</script>

<template>
  <div :class="rootClasses" class="c-content-block-info-box">
    <div class="c-content-block-info-box__box u-markdown-root" v-html="parseMarkdown(richText)" />
  </div>
</template>

<style lang="scss" scoped>
  @use '/assets/scss/util/color/color' as col;
  @use '/assets/scss/util/anaglyph/anaglyph' as anaglyph;

  $offset: 4px;

  .c-content-block-info-box {
    overflow: hidden;
  }

  .c-content-block-info-box__box {
    @include anaglyph.with-shadow-apply(mono, $offset, $offset, 0, 0, col.$monochrome-lead);
    background-color: col.$variant-cyan-light;
    padding: 24px;
    margin: 0 $offset $offset 0;
  }
</style>
